import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {Query} from 'react-apollo';
import {normalizeEdges} from 'utils/misc';
import {NetworkError} from 'components/GraphQLError/NetworkError/index';
import {WithOrganization} from 'api/organizations/withOrganization/index';


export const EMPLOYMENT_QUERY = gql`
query meAndMyEmployment($organizationId: ID!){
  me {
    id
    employments(organizationId: $organizationId) {
      edges {
        node {
          id
          organization {
            id
            name
          }
          user {
            id
            firstName
            lastName
            email
          }
          jobTitle
        }
      }
    }
  }
}
`;

export const employmentShape = PropTypes.shape({
    id: PropTypes.string,
    teams: PropTypes.array,
    jobTitle: PropTypes.string,
    organizationRole: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
    }),
    supervisor: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string
    }),
    user: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string
    })
});


export class WithEmploymentAtOrganization extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        onError: PropTypes.func
    };

    static defaultProps = {
        onError: (error, refetch) => <NetworkError error={error} refetch={refetch}/>
    };

    getEmployment = (data) => {
        if (!data || !data.me) {
            return {};
        }

        const employments = normalizeEdges(data.me.employments);

        // TODO: Don't assume first employment
        return employments && employments.length > 0 ? employments[0] : {};
    };

    render() {
        return (
            <WithOrganization>
                {({loading: loadingOrganization, organization}) => {
                    if (loadingOrganization) {
                        return null;
                    }

                    const organizationId = organization ? organization.id : null;

                    return (
                        <Query query={EMPLOYMENT_QUERY} notifyOnNetworkStatusChange={true} skip={!organizationId} variables={{organizationId: organizationId}}>
                            {({data, loading, error, refetch}) => error ? this.props.onError(error, refetch) : this.props.children({loading, employment: this.getEmployment(data)})}
                        </Query>
                    );
                }}
            </WithOrganization>
        );
    }
}


export function withEmploymentAtOrganization(WrappedComponent, returnLoading = false) {
    class InnerWithEmploymentAtOrganization extends React.PureComponent {

        render() {
            return (

                <WithEmploymentAtOrganization>
                    {({loading, employment}) => {
                        if (loading && !returnLoading) {
                            return null;
                        }

                        return <WrappedComponent loading={loading} employment={employment} {...this.props}/>;

                    }}
                </WithEmploymentAtOrganization>
            );
        }
    }

    return InnerWithEmploymentAtOrganization;
}

